// @flow

// Libs
import _map from 'lodash/map'
import _uniqueId from 'lodash/uniqueId'
import React, { Component } from 'react'

// Components
import { Dialog, DialogBody, DialogFooter, DialogHeader, DialogTitle } from 'react-mdc-web/lib/Dialog'
import Button from '@react-mdc/button'

// Utils
import traverse from 'fc-utils/traverse'

// Operator
import { ImportJobsPopupOperation } from 'hfty-operator-import-jobs-popup/types'

// Constants
import {
  PROP_ERRORS,
  PROP_IS_PARTIALLY_SUCCESSFUL_IMPORT,
  PARAM_HEFTY_FIELD_ID,
  PARAM_REASON,
} from 'hfty-model-import-jobs-popup'

import {
  MSG_POPUP_HEADING,
  MSG_JOB_IMPORT_FAILED,
  MSG_JOBS_IMPORT_FAILED,
  MSG_SUCCESSFUL_IMPORT,
  MSG_PARTIALLY_SUCCESSFUL_IMPORT,
  MSG_OK_BUTTON,
} from '../constants'

// Localization
import { FormattedMessage } from 'react-intl'
import messages from '../messages'

// Styles
import {popup as styles} from './styles'

// Types
type Props = {
  isOpen: boolean,
  onClose: Function,
  importJobsPopupOperation: ImportJobsPopupOperation,
  importJobsPopupOperations: Array<ImportJobsPopupOperation>,
}

// Getters
const getErrors = traverse(['model', PROP_ERRORS], { default: [] })
const getImportStatus = traverse(['model', PROP_IS_PARTIALLY_SUCCESSFUL_IMPORT], { default: null })

export default class ImportJobsPopup extends Component {
  props: Props

  constructor (props: Props) {
    super(props)

    this.closePopup = this.closePopup.bind(this)
  }

  closePopup (e: Event) {
    e.preventDefault()

    this.props.onClose(this.props.importJobsPopupOperations)
  }

  renderErrors (errors: Array<Object>): ?React.Element<any> {
    const errorMessage = errors.length === 1
      ? MSG_JOB_IMPORT_FAILED
      : MSG_JOBS_IMPORT_FAILED

    return (
      <div style={styles.errorsHolder}>
        <h3 style={styles.errorsHeader}>
          <FormattedMessage {...messages[errorMessage]} />
        </h3>
        <ul>
          {_map(errors, (error: Object): ?React.Element<any> => (
            <li key={_uniqueId('importJobResponseError')}>
              <span style={styles.failedJobId}>{error[PARAM_HEFTY_FIELD_ID]}</span> {error[PARAM_REASON]}
            </li>
          ))}
        </ul>
      </div>
    )
  }

  render (): ?React.Element<any> {
    const errors = getErrors(this.props.importJobsPopupOperation)
    const isPartiallySuccessfulImport = getImportStatus(this.props.importJobsPopupOperation)
    const allImported = errors.length === 0
    const partiallySuccessfulImport = errors.length > 0 && isPartiallySuccessfulImport

    return (
      <Dialog open={this.props.isOpen}>
        <div style={styles.dialogWrapper}>
          <DialogHeader>
            <DialogTitle>
              <FormattedMessage {...messages[MSG_POPUP_HEADING]} />
            </DialogTitle>
          </DialogHeader>
          <DialogBody>
            <div style={styles.dialogBody}>
              {allImported && <FormattedMessage {...messages[MSG_SUCCESSFUL_IMPORT]} />}
              {errors.length > 0 && this.renderErrors(errors)}
              {partiallySuccessfulImport && <p style={styles.topOffset}>
                <FormattedMessage {...messages[MSG_PARTIALLY_SUCCESSFUL_IMPORT]} />
              </p>}
            </div>
          </DialogBody>
          <DialogFooter>
            <Button raised primary style={styles.button} onClick={this.closePopup}>
              <FormattedMessage {...messages[MSG_OK_BUTTON]} />
            </Button>
          </DialogFooter>
        </div>
      </Dialog>
    )
  }
}
